import { UseFormRegisterReturn } from "react-hook-form"
import styled from "styled-components"

interface ICheckboxProps {
  label: string
  registration?: UseFormRegisterReturn
  value: string
}

const CHECKBOX_SIZE_EM = 0.65

const StyledCheckbox = styled.input.attrs((props) => ({ type: "checkbox" }))`
  /* Add if not using autoprefixer */
  -webkit-appearance: none;
  /* Remove most all native input styles */
  appearance: none;
  /* For iOS < 15 */
  background-color: ${(props) => props.theme.colors.boxBackground}
  /* Not removed via appearance */
  margin: 0;

  font: inherit;
  color: currentColor;
  width: 1.15em;
  height: 1.15em;
  border: 0.1em solid  ${(props) => props.theme.colors.border};
  transform: translateY(-0.075em);

  display: grid;
  place-content: center;

  &:checked {
    background-color: ${(props) => props.theme.colors.primary}
  }

  &:before {
    content: "";
    width: ${CHECKBOX_SIZE_EM}em;
    height: ${CHECKBOX_SIZE_EM}em;
    clip-path: polygon(14% 44%, 0 65%, 50% 100%, 100% 16%, 80% 0%, 43% 62%);
    transform: scale(0);
    transform-origin: bottom left;
    box-shadow: inset 1em 1em white;
  }

  &:checked::before {
    transform: scale(1);
  }
`

const Span = styled.span`
  margin-block-end: ${CHECKBOX_SIZE_EM / 2}em;
`

const Label = styled.label`
  font-family: ${(props) => props.theme.fontFamilyJA};
  font-size: 0.8rem;
  font-size: clamp(0.8rem, 0.75rem + 0.25vw, 1.05rem);

  display: flex;
  justify-content: center;
  align-items: center;
  gap: clamp(0.5rem, 0.4625rem + 0.1875vw, 0.6875rem);

  cursor: pointer;

  position: relative;
`

const Checkbox = (props: ICheckboxProps) => {
  const { label, registration, value } = props
  return (
    <Label htmlFor={value}>
      <StyledCheckbox value={value} id={value} {...registration} />
      {/* <Checkmark /> */}
      {/* {label} */}
      <Span>{label}</Span>
    </Label>
  )
}

export { Checkbox }
